import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { convertQueryToSearchCondition } from "../convertQueryToSearchCondition";
import { roundTimestamp } from "../roundTimestamp";

import type { EventSearchCondition } from "../../types/eventSearchCondition";
import type { GoodsSearchCondition } from "../../types/goodsSearchCondition";
import type { Dispatch } from "react";

type Input = {
  handleSearchEvent: (condition: EventSearchCondition) => void;
  handleSearchGoods: (condition: GoodsSearchCondition) => void;
  setKeyword: Dispatch<string>;
};
type UseSearch = (input: Input) => void;

export const useSearch: UseSearch = (input) => {
  const { handleSearchEvent, handleSearchGoods, setKeyword } = input;
  const { search } = useLocation();

  useEffect(() => {
    const {
      availabilityStatus,
      endDateFromQuery,
      eventTypeFromQuery,
      genreFromQuery,
      hasQueryForSearch,
      keywordFromQuery,
      prefectureCodesFromQuery,
      startDateFromQuery,
    } = convertQueryToSearchCondition({ search });

    if (!hasQueryForSearch) return;

    setKeyword(keywordFromQuery);
    handleSearchEvent({
      eventType: eventTypeFromQuery?.map(Number),
      keyword: keywordFromQuery,
      genre: genreFromQuery,
      openingDateLte: endDateFromQuery
        ? BigInt(roundTimestamp(endDateFromQuery.getTime(), "roundToEnd"))
        : undefined,
      openingDateGte: startDateFromQuery
        ? BigInt(roundTimestamp(startDateFromQuery.getTime(), "roundToStart"))
        : undefined,
      prefectureCodes: prefectureCodesFromQuery,
      availabilityStatus,
    });
    handleSearchGoods({ keyword: keywordFromQuery });
    // 結果に影響を与えうるのは search のみ
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]);
};
